export function renderDatabaseImportsTemplate({ join }: { join: string }): string {
  return `import {
  ${join}
} from 'drizzle-orm/pg-core'`
}
